// extracted by mini-css-extract-plugin
export var audioPlayer = "_tz-0";